import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "chat-tabs" }
const _hoisted_4 = { class: "user-count" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = { class: "admin-modal" }
const _hoisted_7 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Giveaway = _resolveComponent("Giveaway")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Button = _resolveComponent("Button")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_AdminGlobalChat = _resolveComponent("AdminGlobalChat")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#chat-container" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["chat-panel", { mobile: _ctx.isMobile }]),
      style: _normalizeStyle({ display: _ctx.isOpen ? 'flex' : 'none' })
    }, [
      (_ctx.hasGiveawaysBanner)
        ? (_openBlock(), _createBlock(_component_Slider, {
            key: 0,
            autoplay: 3000,
            items: _ctx.chatGiveaways,
            "item-key-prop": "id"
          }, {
            slide: _withCtx(({ item }) => [
              _createVNode(_component_Giveaway, { giveaway: item }, null, 8, ["giveaway"])
            ]),
            _: 1
          }, 8, ["items"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Tabs, { tabs: _ctx.chatTabs }, null, 8, ["tabs"])
          ]),
          _createVNode(_component_Button, {
            class: "pin-message",
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPinModal = true))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Pin message ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_UserIcon),
              _createTextVNode(" " + _toDisplayString(_ctx.globalConfig.data.onlineUsersCount?.toLocaleString()), 1)
            ]),
            _createElementVNode("div", {
              class: "arrow",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _createVNode(_component_Arrow, { style: {"transform":"rotate(90deg)"} })
            ])
          ])
        ])
      ]),
      _createVNode(_component_AdminGlobalChat, { "is-open": _ctx.isOpen }, null, 8, ["is-open"])
    ], 6),
    (_ctx.showPinModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _ctx.closeActionModal,
          img: "Modal-background.png",
          name: "Pin message"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pinMessageTitle) = $event)),
                type: "text",
                placeholder: "Title"
              }, null, 512), [
                [_vModelText, _ctx.pinMessageTitle]
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pinMessageContent) = $event)),
                rows: "4",
                placeholder: "Message"
              }, null, 512), [
                [_vModelText, _ctx.pinMessageContent]
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Button, {
                  type: "primary__white",
                  size: "small",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPinModal = false))
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.sendPinMessage
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Send ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}